import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Title as ScreenTitle } from 'components'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { SmallSpace } from 'styles/GlobalStyle'
import AssessmentDetails from '../Assessment/AssessmentDetails'

const ReportHeader = (props) => {
    const { batteryAction } = props
    const { assessment } = useSelector(state => state.assessment)
    const { battery_label } = assessment || {}

    const navigate = useNavigate()

    const goAssessments = useCallback(() => {
        navigate(app.assessments)
    }, [])

    return (
        <React.Fragment>
            <ScreenTitle {...props} breadcrumbs={true}>
                {battery_label ?
                    <div className='bread-crumbs-title'>
                        <div onClick={() => batteryAction?.() || goAssessments()} className='title'>{"דוחות"}</div>
                        <div>{">"}</div>
                        <div>{"סוללות מבדקים"}</div>
                        <div>{"-"}</div>
                        <div>{battery_label}</div>
                        <div>{"-"}</div>
                        <div>{"דוח אישי"}</div>
                    </div> :
                    <div className='bread-crumbs-title'>
                        <div className='title' onClick={goAssessments}>{"דוחות"}</div>
                        <div>{">"}</div>
                        <div>{"מבדקים מבודדים"}</div>
                        <div>{"-"}</div>
                        <div>{"דוח אישי"}</div>
                    </div>
                }
            </ScreenTitle>
            <AssessmentDetails />
        </React.Fragment>
    )
}

export default ReportHeader